import styled from 'styled-components';
import { palette } from 'styled-tools';
import { TextArea } from 'components';

export const TextAreaIntroduce = styled(TextArea)`
    &:not(:focus) {
        background: ${palette('gray_opacity_100')};
    }

    /* IE10 이상을 위한 css */
    &:not(:placeholder-shown) {
        background: ${palette('gray_opacity_50')};
    }

    &:not(:-webkit-input-placeholder) {
        background: ${palette('gray_opacity_50')};
    }
    /* IE */
    &:not(:-ms-input-placeholder) {
        background: ${palette('gray_opacity_50')};
    }
    /* Firefox */
    &:not(:-mos-input-placeholder) {
        background: ${palette('gray_opacity_50')};
    }
`;